import { Inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { BrowserStorage } from "@appcore/_helpers/browserstorage";
import { UserService } from "@service/user.service";
import { ColorUtility } from "@service/system/utilities.service";
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from "@okta/okta-auth-js";

/**
 * The authentication configuration that is to be consumed by an authentication
 * factory. The {@link authorizationProvider} determines which authentication
 * service implemententation will be used by the factory.
 *
 * @author    John Ying <john.ying@childrenshospitals.org>
 * @created   9/22/2022
 */
@Injectable({ providedIn: "root" })
export class AuthenticationConfiguration {
	public authorizationProvider = "okta";

	constructor(
		public storageService: BrowserStorage,
		public colorUtil: ColorUtility,
		@Inject(OKTA_AUTH) public oktaBare: OktaAuth,
		public router: Router,
		public userService: UserService
	) {}
}
